
import { Component, Vue } from 'vue-property-decorator'
import NotifyTemplateService from '@/biz/service/Notify/NotifyTemplateService'
import { ISearchFields } from '@/interface/common'
import RouterService from '@/service/RouterService'

@Component
export default class ViewOtherWeChatNotifyTemplateIndex extends Vue {
  private Service = NotifyTemplateService
  private RouterService = RouterService

  private searchFields: ISearchFields[] = [
    {
      name: 'template_id',
      display_name: '微信模板ID',
      valueType: 'string'
    }
  ]
}
